import {Box, Button, Group, Stack, Text} from "@mantine/core";
import {useTranslation} from "react-i18next";
import IconRefresh from "../../../../assets/refresh.svg?react";

interface Props {
    onRetry: () => void;
}

export const InterruptedTurn: React.FC<Props> = ({onRetry}) => {
    const {t} = useTranslation();
    return (
        <Box
            p="lg"
            ml={42}
            bg="gneis.0"
            style={{
                borderRadius: "var(--mantine-radius-md)",
            }}
        >
            <Group justify="space-between" wrap="nowrap" align="center" gap="md">
                <Stack gap={4}>
                    <Text fw={700}>
                        {t("error.interrupted.title", {
                            defaultValue: "Svaret ble avbrutt",
                        })}
                    </Text>
                    <Text size="sm">
                        {t("error.interrupted.body", {
                            defaultValue:
                                "Det forrige svaret ble ikke fullført. Prøv spørsmålet på nytt for å få et nytt svar.",
                        })}
                    </Text>
                </Stack>
                <Button
                    variant="subtle"
                    size="xs"
                    color="dark"
                    onClick={onRetry}
                    leftSection={<IconRefresh height="16px" />}
                    style={{flexShrink: 0}}
                >
                    {t("common.tryAgain")}
                </Button>
            </Group>
        </Box>
    );
};
